export default {
    api: {
        url: 'https://api.billing.asdqwe.nl'
    }
};
